import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useNavigation, useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Button, Screen, Text } from '@components'
import { useLanguage } from '@context'
import { useCurrentUserStore } from '@store'
import type { AppNavigationProp } from '../../navigation/navigationTypes'

// Web only: shown for an address that leads to no page of the app.
export const NotFound: React.FC = () => {
  const theme = useTheme()
  const { t } = useLanguage()
  const navigation = useNavigation<AppNavigationProp>()
  const styles = getStyles(theme)
  // A public event link that was cut or badly copied shows this page to a
  // visitor without an account: no contacts to go back to.
  const isUserLogged = !!useCurrentUserStore((state) => state.userID)

  return (
    <Screen>
      <View style={styles.container} testID="not-found-screen">
        <Text type="headline" color={theme.colors.primary} style={styles.text}>
          {t('notFoundPage.title')}
        </Text>
        <Text type="bodySmall" color={theme.colors.greyBlue} style={styles.text}>
          {t('notFoundPage.message')}
        </Text>
        <Button
          unfilled
          borderWidth={2}
          containerStyle={styles.button}
          title={t(isUserLogged ? 'notFoundPage.button' : 'notFoundPage.buttonLoggedOut')}
          onPress={() =>
            navigation.reset({ index: 0, routes: [{ name: isUserLogged ? 'Tab' : 'Auth' }] })
          }
        />
      </View>
    </Screen>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing.lg,
      paddingHorizontal: theme.spacing.xl,
    },
    text: {
      textAlign: 'center',
    },
    button: {
      maxWidth: 320,
    },
  })
